import MenuItemBox from './MenuItemBox.jsx';
export default function SubMenuDispatcher({
  href = '#',
  itemText,
  newTab = false,
  ariaLabel = '',
  externalCallback,
  iconName = '',
  iconPosition = 'after',
  isOpen,
  index,
  menuItemIndex,
}) {
  return (
    <li
      tabIndex="-1"
      className="lds-header-menu-item lds-header-menu-item-type-link"
    >
      <div className="lds-header-menu-item-content">
        <MenuItemBox
          itemText={itemText}
          newTab={newTab}
          href={href}
          type="link"
          ariaLabel={ariaLabel}
          externalCallback={externalCallback}
          iconName={iconName}
          iconPosition={iconPosition}
          isOpen={isOpen}
          index={index}
          menuItemIndex={menuItemIndex}
        />
      </div>
    </li>
  );
}
